
import { useEffect, useState } from "react";
import FeatureContainer from "../../../../Layout/Containers/FeatureContainer";
import useAxios from "../../../../Utils/useAxios";
import getKurirList from "../serivces/getKurirList";
import KurirModal from "../components/KurirModal";
import KurirList from "../components/KurirList";

const PengaturanKurirContain = () => {
  const [kurirList, setKurirList] = useState([]);
  const [pending, setPending] = useState(true);
  const axiosInstance = useAxios();

  useEffect(() => {
    refreshKurirList();
  }, []);

  const refreshKurirList = async () => {
    setPending(true);
    getKurirList(axiosInstance).then((res) => {
      setKurirList(res.data);
      setPending(false);
    });
  }

  return (
    <FeatureContainer
     type="pengaturan"
     createButton={
      <KurirModal create={true} resetState={refreshKurirList} />
     }
    >
      <KurirList items={kurirList} resetState={refreshKurirList} pending={pending}/>
    </FeatureContainer>
  );
};

export default PengaturanKurirContain;
